<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">
                'Select S3 Path'
            </h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <FileBrowser :generateURL="this.modalData.generateURL" @onFileSelect="handleFileSelection" @onFileClicked="handleFileClicked" @onSandboxChange="handleSandboxChange"/>
            <div v-if="selectedFileData" class="text-center mt-3">
                <button @click="chooseFile" class="btn btn-primary"
                    :disabled="loading || (!selectedFileData.presignedUrl && this.modalData.generateURL)">
                    <div v-if="loading" class="spinner-border spinner-border-sm me-2" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <span v-if="loading">
                        Getting presigned URL for {{ getFileName(selectedFileData.name) }}...
                    </span>
                    <span v-else>
                        Choose {{ getFileName(selectedFileData.name) }}
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import FileBrowser from '../sandbox/FileBrowser.vue';
export default {
    name: "FileSelectionModal",
    components: { FileBrowser },
    props: {
       modalData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            selectedFileData: null,
            selectedSandbox: null,
            loading: false
        };
    },
    methods: {
        handleFileClicked(data) {
            this.selectedFileData = { name: data.name };
            this.loading = true;
        },
        handleFileSelection(data) {
            this.selectedFileData = data;
            this.loading = false;
        },
        handleSandboxChange(data) {
            this.selectedSandbox = data;
        },
        getFileName(fullPath) {
            if (!fullPath) return '';
            return fullPath.split('/').pop() || fullPath;
        },
        chooseFile() {
            if (this.selectedFileData && (this.selectedFileData.presignedUrl || !this.modalData.generateURL)) {
                if (this.modalData && this.modalData.onFileSelected && typeof this.modalData.onFileSelected === 'function') {
                    this.modalData.onFileSelected({
                        s3Path: this.selectedFileData.name,
                        presignedUrl: this.selectedFileData.presignedUrl,
                        sandbox: this.selectedSandbox
                    });
                }
                this.$store.dispatch('hideModal');
            }
        }
    }
};
</script>

<style scoped></style>